import type { IRecentlyVisitedPageDto } from '@condo/domain';
import { getClient } from './api-client';

export const saveRecentPageVisit = async (params: IRecentlyVisitedPageDto[]): Promise<any> =>
    getClient('listingPersister').saveRecentlyVisitedPages({
        pages: params,
    });
